var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.75 0C20.4779 0 23.5 3.02208 23.5 6.75V16.75C23.5 20.4779 20.4779 23.5 16.75 23.5H6.75C3.02208 23.5 0 20.4779 0 16.75V6.75C0 3.02208 3.02208 0 6.75 0H16.75ZM16.75 1.5H6.75C3.85051 1.5 1.5 3.85051 1.5 6.75V16.75C1.5 19.6495 3.85051 22 6.75 22H16.75C19.6495 22 22 19.6495 22 16.75V6.75C22 3.85051 19.6495 1.5 16.75 1.5ZM12.4932 5.64823C12.4435 5.28215 12.1297 5 11.75 5L11.6482 5.00685L11.5506 5.02679C11.2332 5.11411 11 5.40482 11 5.75V10.999L5.75 11L5.64823 11.0068C5.28215 11.0565 5 11.3703 5 11.75L5.00685 11.8518C5.05651 12.2178 5.3703 12.5 5.75 12.5L11 12.499V17.75L11.0068 17.8518C11.0565 18.2178 11.3703 18.5 11.75 18.5L11.8518 18.4932C12.2178 18.4435 12.5 18.1297 12.5 17.75V12.5H17.75L17.8518 12.4932C18.2178 12.4435 18.5 12.1297 18.5 11.75L18.4932 11.6482C18.4435 11.2822 18.1297 11 17.75 11H12.5V5.75L12.4932 5.64823Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.03acfc86d284bc7dbf40039880e0eb19.svg";
export { ForwardRef as ReactComponent };